<!--
 * @Author: wangchao
 * @Date: 2021-06-19 
 * @LastEditors: wzc
 * @LastEditTime: 2021-06-02 16:49:10
 * 关键事件包括： 点球，进球，乌龙球，下场，黄牌，红牌，上场，受伤 (0~7)
 * 首发球员主队位置排序完之后人数不是11个，不会展示该首发阵容，替补阵容正常展示
 * 首发阵容中如果有球员没有playerId、playerName和阵容位置则过滤掉该球员，过滤后不足11人隐藏首发阵容
 * 替补阵容如果没有则隐藏替补阵容那块，首发阵容正常展示
 * 替补阵容中如果有球员没有playerId和playerName则过滤掉该球员，其他球员正常展示

-->

<template>
  <div class="MATCHLINEUP" v-show="data && data.base && data.base.length == 2">
    <div class="matchLineup_title" v-text="_valFormatHandler(data.title)"></div>
    <div class="btnArea">
      <span class="tabBtns">
        <span
          class="teamLineup"
          :class="tab.act ? 'act' : ''"
          v-for="tab in tabArr"
          :key="tab.key"
          @click="clickTab(tab)"
        >
          <span class="teamLogo">
            <img :src="tab.teamLogo ? tab.teamLogo : defaultTeamImg" />
          </span>
          <span class="lineupType" v-text="_valFormatHandler(tab.name)"></span>
        </span>
      </span>
    </div>
    <div class="startLineupBox" v-show="isThemeFlagArr.length == 0">
      <div class="startLineup_title">
        <span class="title" v-text="'首发阵容'"></span>
        <span
          class="coachName"
          v-text="`主教练：${_valFormatHandler(cruCoach)}`"
        ></span>
      </div>
      <div class="footballField_container" :class="actLineupType">
        <span
          class="playerItem"
          v-for="(item, index) in startPlayerList"
          :key="index"
          @click="openFloatLayer(item, 'start')"
        >
          <span class="playerLogo">
            <img v-show="item.playerLogo" :src="item.playerLogo" />
            <span v-show="!item.playerLogo" class="defautlPlayerImg"></span>
            <span class="playerNum" v-text="item.playerNum"></span>
            <span class="playerEvents">
              <span
                class="eventTop"
                v-for="(events, eventsIndex) in item.eventCodeWebs"
                :key="eventsIndex"
                :class="eventsIndex == 0 ? 'eventTop' : 'eventBottom'"
              >
                <span
                  class="eventItem"
                  v-for="event in events"
                  :key="event"
                  :class="[
                    event === 3 ? 'offStage' : '',
                    event === 4 ? 'yellowCard' : '',
                    event === 5 ? 'redCard' : '',
                    event === 0 ? 'point' : '',
                    event === 1 ? 'goal' : '',
                    event === 2 ? 'ownGoal' : '',
                  ]"
                ></span>
                <!-- <span class="eventItem yellowCard"></span>
                  <span class="eventItem redCard"></span>
                  <span class="eventItem offStage"></span> -->
              </span>
              <!-- <span class="eventBottom">
                  <span class="eventItem goal"></span>
                  <span class="eventItem point"></span>
                  <span class="eventItem ownGoal"></span>
                </span> -->
            </span>
          </span>
          <span class="playerName" v-text="item.playerName"></span>
        </span>
      </div>
    </div>
    <div class="subLineupBox" v-if="subPlayerList && subPlayerList.length > 0">
      <div class="subLineup_title" v-text="'替补阵容'"></div>
      <div
        class="viewBox"
        :style="{
          height: `calc(${viewBoxHeight})`,
        }"
      >
        <ul class="tableUl">
          <li
            class="itemRow"
            v-for="(player, index) in subPlayerList"
            :key="player.playerId"
            :style="{
              opacity: `${index > shrinkRowNum - 1 && !shrinkTypeFlag ? 0 : 1}`,
            }"
          >
            <span class="leftPlayerItem" @click="openFloatLayer(player, 'sub')">
              <span class="playerLogo">
                <img v-show="player.playerLogo" :src="player.playerLogo" />
                <span
                  v-show="!player.playerLogo"
                  class="defautlPlayerImg"
                ></span>
                <span
                  class="playerNum"
                  v-text="_valFormatHandler(player.playerNum)"
                ></span>
              </span>
              <span class="inforRow">
                <span class="inforRow_1">
                  <span
                    class="playerName"
                    v-text="_valFormatHandler(player.playerName)"
                  ></span>
                  <span
                    class="playerPos"
                    v-text="_valFormatHandler(player.playerPosition)"
                  ></span>
                  <span
                    class="playerGrade"
                    v-text="_valFormatHandler(player.playerGrade)"
                  ></span>
                </span>
                <span
                  class="inforRow_2"
                  v-if="player.playerEvents && player.playerEvents.length > 0"
                >
                  <template v-for="(event, eventIndex) in player.playerEvents">
                    <span
                      v-if="event.eventCodeWeb - 0 == 7"
                      :key="eventIndex"
                      v-text="'受伤'"
                      :class="
                        eventTypeClass[event.eventCodeWeb]
                          ? eventTypeClass[event.eventCodeWeb]
                          : ''
                      "
                    ></span>
                    <span
                      v-if="
                        event.eventCodeWeb - 0 >= 0 &&
                        event.eventCodeWeb - 0 <= 6
                      "
                      :key="eventIndex"
                      v-text="
                        event.eventCodeWeb == 3 || event.eventCodeWeb == 6
                          ? _valFormatHandler(event.time)
                          : ''
                      "
                      :class="
                        eventTypeClass[event.eventCodeWeb]
                          ? eventTypeClass[event.eventCodeWeb]
                          : ''
                      "
                    ></span>
                  </template>
                  <!-- <span class="goal"></span>
                    <span class="yellowCard"></span>
                    <span class="redCard"></span>
                    <span class="offStage" v-text="'45'"></span> -->
                </span>
              </span>
            </span>
            <span
              class="rightPlayerItem"
              v-if="player.startPlayer && player.startPlayer.playerName"
            >
              <span class="inforRow">
                <span class="inforRow_1">
                  <span
                    class="playerName"
                    v-text="_valFormatHandler(player.startPlayer.playerName)"
                  ></span>
                  <span
                    class="playerGrade"
                    v-text="_valFormatHandler(player.startPlayer.playerGrade)"
                  ></span>
                </span>
                <span
                  class="inforRow_2"
                  v-show="
                    player.startPlayer.playerEvents &&
                    player.startPlayer.playerEvents.length > 0
                  "
                >
                  <template
                    v-for="(event, eventIndex) in player.startPlayer
                      .playerEvents"
                  >
                    <span
                      :key="eventIndex"
                      v-text="
                        event.eventCodeWeb == 3 || event.eventCodeWeb == 6
                          ? _valFormatHandler(event.time)
                          : ''
                      "
                      v-if="
                        event.eventCodeWeb - 0 >= 0 &&
                        event.eventCodeWeb - 0 <= 6
                      "
                      :class="eventTypeClass[event.eventCodeWeb]"
                    ></span>
                  </template>
                </span>
              </span>
            </span>
          </li>
        </ul>
        <div class="shrinkBox" v-if="isShrinkFlag" @click="shrinkTypeHandler">
          <span class="shrinkText" v-text="shrinkText"></span>
          <span
            class="arrowIcon unquoteClass"
            :class="shrinkTypeFlag ? '' : 'show'"
          ></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// 阵容
import lineupLayoutMap from './lineup_layout.json'
export default {
  name: 'matchLineUp',
  data() {
    return {
      data: {
        title: '阵容',
        storeKey: 'matchLineUp',
        base: [
          {
            teamLogo:
              'https://images.mixtmt.com/img-euro/teams/TUR/TUR_240x240.png',
            coach: '科斯明·奥拉罗尤',
            lineupType: '31312',
          },
          {
            teamLogo:
              'https://images.mixtmt.com/img-euro/teams/TUR/TUR_240x240.png',
            coach: '111科斯明·奥拉罗尤',
            lineupType: '352',
          },
        ],
        startLineups: [
          //首发阵容
          [
            {
              shirtNumber: 23,
              playerName: '安德里斯·诺珀特',
              playerId: 102907,
              position: 'GK',
              positionName: '守门员',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102907.png',
              formationUsed: '352',
              formationPlace: 1,
              formationShow: '3-5-2',
              x: '1900',
              y: '120',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '安德里斯·诺珀特(GK)',
            },
            {
              shirtNumber: 5,
              playerName: '内森·阿克',
              playerId: 100203,
              position: 'B',
              positionName: '后卫',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100203.png',
              formationUsed: '352',
              formationPlace: 4,
              formationShow: '3-5-2',
              x: '1140',
              y: '660',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '内森·阿克(B)',
            },
            {
              shirtNumber: 4,
              playerName: '弗吉尔·范戴克',
              playerId: 102334,
              position: 'B',
              positionName: '后卫',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102334.png',
              formationUsed: '352',
              formationPlace: 5,
              formationShow: '3-5-2',
              x: '1900',
              y: '660',
              isCaptain: 1,
              teamLogo: '',
              playerNameWeb: '弗吉尔·范戴克(B)',
            },
            {
              shirtNumber: 2,
              playerName: '于连·廷贝尔',
              playerId: 100211,
              position: 'B',
              positionName: '后卫',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100211.png',
              formationUsed: '352',
              formationPlace: 6,
              formationShow: '3-5-2',
              x: '2660',
              y: '660',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '于连·廷贝尔(B)',
            },
            {
              shirtNumber: 17,
              playerName: '戴利·布林德',
              playerId: 100197,
              position: 'M',
              positionName: '中场',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100197.png',
              formationUsed: '352',
              formationPlace: 3,
              formationShow: '3-5-2',
              x: '1080',
              y: '1170',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '戴利·布林德(M)',
            },
            {
              shirtNumber: 21,
              playerName: '弗伦基·德容',
              playerId: 100218,
              position: 'M',
              positionName: '中场',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100218.png',
              formationUsed: '352',
              formationPlace: 8,
              formationShow: '3-5-2',
              x: '1430',
              y: '1065',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '弗伦基·德容(M)',
            },
            {
              shirtNumber: 8,
              playerName: '科迪·加克波',
              playerId: 100207,
              position: 'M',
              positionName: '中场',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100207.png',
              formationUsed: '352',
              formationPlace: 11,
              formationShow: '3-5-2',
              x: '1900',
              y: '975',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '科迪·加克波(M)',
            },
            {
              shirtNumber: 15,
              playerName: '马尔滕·德罗恩',
              playerId: 100208,
              position: 'M',
              positionName: '中场',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100208.png',
              formationUsed: '352',
              formationPlace: 7,
              formationShow: '3-5-2',
              x: '2370',
              y: '1065',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '马尔滕·德罗恩(M)',
            },
            {
              shirtNumber: 22,
              playerName: '登塞尔·邓弗里斯',
              playerId: 100195,
              position: 'M',
              positionName: '中场',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100195.png',
              formationUsed: '352',
              formationPlace: 2,
              formationShow: '3-5-2',
              x: '2710',
              y: '1170',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '登塞尔·邓弗里斯(M)',
            },
            {
              shirtNumber: 10,
              playerName: '孟菲斯·德佩',
              playerId: 100212,
              position: 'F',
              positionName: '前锋',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100212.png',
              formationUsed: '352',
              formationPlace: 9,
              formationShow: '3-5-2',
              x: '1590',
              y: '1400',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '孟菲斯·德佩(F)',
            },
            {
              shirtNumber: 7,
              playerName: '史蒂文·贝赫韦因',
              playerId: 102497,
              position: 'F',
              positionName: '前锋',
              teamId: 1054,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102497.png',
              formationUsed: '352',
              formationPlace: 10,
              formationShow: '3-5-2',
              x: '2210',
              y: '1400',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '史蒂文·贝赫韦因(F)',
            },
          ],
          [
            {
              shirtNumber: 23,
              playerName: '埃米利亚诺·马丁内斯',
              playerId: 100672,
              position: 'GK',
              positionName: '守门员',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100672.png',
              formationUsed: '352',
              formationPlace: 1,
              formationShow: '3-5-2',
              x: '1900',
              y: '120',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '埃米利亚诺·马丁内斯(GK)',
            },
            {
              shirtNumber: 25,
              playerName: '利桑德罗·马丁内斯',
              playerId: 102634,
              position: 'B',
              positionName: '后卫',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102634.png',
              formationUsed: '352',
              formationPlace: 4,
              formationShow: '3-5-2',
              x: '1140',
              y: '660',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '利桑德罗·马丁内斯(B)',
            },
            {
              shirtNumber: 19,
              playerName: '尼古拉斯·奥塔门迪',
              playerId: 100720,
              position: 'B',
              positionName: '后卫',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100720.png',
              formationUsed: '352',
              formationPlace: 5,
              formationShow: '3-5-2',
              x: '1900',
              y: '660',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '尼古拉斯·奥塔门迪(B)',
            },
            {
              shirtNumber: 13,
              playerName: '克里斯蒂安·罗梅罗',
              playerId: 102489,
              position: 'B',
              positionName: '后卫',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102489.png',
              formationUsed: '352',
              formationPlace: 6,
              formationShow: '3-5-2',
              x: '2660',
              y: '660',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '克里斯蒂安·罗梅罗(B)',
            },
            {
              shirtNumber: 8,
              playerName: '马科斯·阿库尼亚',
              playerId: 100716,
              position: 'B',
              positionName: '后卫',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100716.png',
              formationUsed: '352',
              formationPlace: 3,
              formationShow: '3-5-2',
              x: '1080',
              y: '1170',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '马科斯·阿库尼亚(B)',
            },
            {
              shirtNumber: 20,
              playerName: '亚历克西斯·麦卡利斯特',
              playerId: 102102,
              position: 'M',
              positionName: '中场',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102102.png',
              formationUsed: '352',
              formationPlace: 8,
              formationShow: '3-5-2',
              x: '1430',
              y: '1065',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '亚历克西斯·麦卡利斯特(M)',
            },
            {
              shirtNumber: 24,
              playerName: '恩索·费尔南德斯',
              playerId: 102629,
              position: 'M',
              positionName: '中场',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102629.png',
              formationUsed: '352',
              formationPlace: 11,
              formationShow: '3-5-2',
              x: '1900',
              y: '975',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '恩索·费尔南德斯(M)',
            },
            {
              shirtNumber: 7,
              playerName: '罗德里戈·德保罗',
              playerId: 102630,
              position: 'M',
              positionName: '中场',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102630.png',
              formationUsed: '352',
              formationPlace: 7,
              formationShow: '3-5-2',
              x: '2370',
              y: '1065',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '罗德里戈·德保罗(M)',
            },
            {
              shirtNumber: 26,
              playerName: '纳韦尔·莫利纳',
              playerId: 102638,
              position: 'B',
              positionName: '后卫',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102638.png',
              formationUsed: '352',
              formationPlace: 2,
              formationShow: '3-5-2',
              x: '2710',
              y: '1170',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '纳韦尔·莫利纳(B)',
            },
            {
              shirtNumber: 9,
              playerName: '胡利安·阿尔瓦雷斯',
              playerId: 102356,
              position: 'F',
              positionName: '前锋',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/102356.png',
              formationUsed: '352',
              formationPlace: 9,
              formationShow: '3-5-2',
              x: '1590',
              y: '1400',
              isCaptain: 0,
              teamLogo: '',
              playerNameWeb: '胡利安·阿尔瓦雷斯(F)',
            },
            {
              shirtNumber: 10,
              playerName: '利昂内尔·梅西',
              playerId: 100704,
              position: 'F',
              positionName: '前锋',
              teamId: 1020,
              playerLogo:
                'https://hyper-sports-res.mixtmt.com/football/season/1092022/person/100704.png',
              formationUsed: '352',
              formationPlace: 10,
              formationShow: '3-5-2',
              x: '2210',
              y: '1400',
              isCaptain: 1,
              teamLogo: '',
              playerNameWeb: '利昂内尔·梅西(F)',
            },
          ],
        ],
        subLineups: [
          //替补阵容
          [
            {
              playerName: '科斯明·奥拉洛尤',
              playerLogo: '',
              playerNum: 23,
              playerId: '124',
              teamId: '1421',
              playerPosition: '中场',
              playerGrade: '9.0', //评分
              playerEvents: [
                {
                  type: 6, //上场
                  time: '35’',
                },
                {
                  type: 0, //点球
                  time: '50’',
                },
                {
                  type: 1, //乌龙球
                  time: '51’',
                },
                {
                  type: 2, //进球
                  time: '55’',
                },
                // {
                //   type: 4, //黄牌
                //   time: "60’",
                // },
                {
                  type: 5, //红牌
                  time: '65’',
                },
                {
                  type: 3, //下场
                  time: '85’',
                },
                {
                  type: 7, //受伤
                  time: '85’',
                },
              ],
              startPlayer: {
                playerName: '林德勒夫',
                playerGrade: '8.7',
                playerEvents: [
                  {
                    type: 3, //下场
                    time: '35’',
                  },
                ],
              },
            },
            {
              playerName: '11科斯明·奥拉洛尤',
              playerLogo: '',
              playerNum: 10,
              playerId: '104',
              teamId: '1421',
              playerPosition: '前锋',
              playerGrade: '9.0', //评分
              playerEvents: [
                {
                  type: 6, //上场
                  time: '35’',
                },
                {
                  type: 0, //点球
                  time: '50’',
                },
                {
                  type: 1, //乌龙球
                  time: '51’',
                },
                {
                  type: 2, //进球
                  time: '55’',
                },
                {
                  type: 4, //黄牌
                  time: '60’',
                },
                {
                  type: 5, //红牌
                  time: '65’',
                },
                {
                  type: 3, //下场
                  time: '85’',
                },
              ],
              startPlayer: {
                playerName: '林德勒夫',
                playerGrade: '8.7',
                playerEvents: [
                  {
                    type: 3, //下场
                    time: '35’',
                  },
                ],
              },
            },
            {
              playerName: '23科斯明·奥拉洛尤',
              playerLogo: '',
              playerNum: 10,
              playerId: '1040',
              teamId: '1421',
              playerPosition: '前锋',
              playerGrade: '', //评分
            },
          ],
          [
            {
              playerName: '科斯明·奥拉洛尤',
              playerLogo: '',
              playerNum: 23,
              playerId: '124',
              teamId: '1421',
              playerPosition: '中场',
              playerGrade: '9.0', //评分
              playerEvents: [
                {
                  type: 6, //上场
                  time: '35’',
                },
                {
                  type: 0, //点球
                  time: '50’',
                },
                {
                  type: 1, //乌龙球
                  time: '51’',
                },
                {
                  type: 2, //进球
                  time: '55’',
                },
                {
                  type: 4, //黄牌
                  time: '60’',
                },
                {
                  type: 5, //红牌
                  time: '65’',
                },
                {
                  type: 3, //下场
                  time: '85’',
                },
              ],
              startPlayer: {
                playerName: '林德勒夫',
                playerGrade: '8.7',
                playerEvents: [
                  {
                    type: 3, //下场
                    time: '35’',
                  },
                ],
              },
            },
            {
              playerName: '22科斯明·奥拉洛尤',
              playerLogo: '',
              playerNum: 10,
              playerId: '104',
              teamId: '1421',
              playerPosition: '前锋',
              playerGrade: '9.0', //评分
              playerEvents: [
                {
                  type: 6, //上场
                  time: '35’',
                },
                {
                  type: 0, //点球
                  time: '50’',
                },
                {
                  type: 1, //乌龙球
                  time: '51’',
                },
                {
                  type: 2, //进球
                  time: '55’',
                },
                {
                  type: 4, //黄牌
                  time: '60’',
                },
                {
                  type: 5, //红牌
                  time: '65’',
                },
                {
                  type: 3, //下场
                  time: '85’',
                },
              ],
              startPlayer: {
                playerName: '林德勒夫',
                playerGrade: '8.7',
                playerEvents: [
                  {
                    type: 3, //下场
                    time: '35’',
                  },
                ],
              },
            },
          ],
        ],
      },
      isThemeFlagArr: [], //当首发球员排序不是主客队不是11个球员，主题隐藏；替补阵容有则展示，无则不展示
      eventTypeClass: [
        'point',
        'ownGoal',
        'goal',
        'offStage',
        'yellowCard',
        'redCard',
        'onStage',
        'injured',
      ],
      // tabArr: [
      //   {
      //     name: "4-1-2-1-2",
      //     key: "home",
      //     teamLogo: "",
      //     act: true,
      //   },
      //   {
      //     name: "4-3-3",
      //     key: "away",
      //     teamLogo: "",
      //     act: false,
      //   },
      // ],
      tabArr: null,
      cruCoach: null,
      showRowNum: 0,
      realityRowNum: 0, //数据实际行数
      shrinkRowNum: 5, //收缩最大值5行
      isShrinkFlag: false, //是否显示 展示||收起 dom, true:显示 ，false：不显示
      shrinkTypeFlag: false, //false: 未展开， true： 展开；
      shrinkText: '展开',
      baseInfor: null,
      actLineupType: null,
      lineupLayoutMap: null,
      allStartPlayerList: [],
      startPlayerList: [],
      subPlayerList: [],
      defaultTeamImg:
        'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJYAAACWCAYAAAA8AXHiAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAlqADAAQAAAABAAAAlgAAAAAXS0ggAAAC5klEQVR4Ae3SsQ3CQBREQYPoG3pADqnVNOCNXjoX3tcmo3ccHgECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAAECBAgQIECAAIEg8Piev3fYmxK4FXhd1/W5vfgkEASeYWtKYAoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT3bKSCsSeNQBIRV9GyngLAmjUMREFbRs50Cwpo0DkVAWEXPdgoIa9I4FAFhFT1bAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgAABAgQIECBAgACB4w8i3waNTi4J/gAAAABJRU5ErkJggg==',
    }
  },
  watch: {
    data: {
      handler(newVal, oldVal) {
        let subPlayerList = []
        let startPlayerList = [] //首发的还没写完，需要正式数据来写，不然首发阵容没法正常显示
        let tabArr = null
        let actTabIndex = -1
        let allStartPlayerList = []
        if (!this.tabArr) {
          if (newVal.base && newVal.base.length == 2) {
            tabArr = newVal.base.map((team, index) => {
              let act = index === 0 ? true : false
              let key = index === 0 ? 'home' : 'away'

              let lineupTypeStr = ''
              if (team.lineupType) {
                if (team.lineupType.indexOf('d') > -1) {
                  lineupTypeStr = '3-4-3d'
                } else {
                  const lineupArr = (team.lineupType + '').split('')
                  if (lineupArr.length > 0) {
                    lineupTypeStr = lineupArr.join('-')
                  }
                }
              }
              if (index == 0) {
                this.cruCoach = this._valFormatHandler(team.coach)
                this.actLineupType = `lineup_${
                  team.lineupType ? team.lineupType : ''
                }`
              }
              return {
                name: lineupTypeStr,
                coach: team.coach,
                key,
                teamLogo: team.teamLogo,
                act,
                lineupType: team.lineupType,
              }
            })
          }
          if (!tabArr) {
            return
          }
          this.tabArr = tabArr
        }
        let formatStartLineups = []
        newVal.startLineups.forEach((teams) => {
          const formatTeams = []
          console.debug('formatTeams:', teams)
          teams.forEach((player) => {
            if (player.events) {
              const eventCodeTops = [],
                eventCodeBottoms = [],
                topCode = [3, 4, 5],
                bottomCode = [0, 1, 2]
              player.events.forEach((event) => {
                const eventCode = this.eventCode2eventCodeWeb(event)
                if (topCode.includes(eventCode)) {
                  eventCodeTops.push(eventCode)
                }
                if (bottomCode.includes(eventCode)) {
                  eventCodeBottoms.push(eventCode)
                }
              })
              player.eventCodeWebs = [eventCodeTops, eventCodeBottoms]
              // if(player.playerId && player.playerName && player.formationPlace){
              //   // 过滤没有playerId、playerName、阵容位置的球员，这球员有问题，因此首发阵容不展示
              //   formatTeams.push(player)
              // }
            }
            if (player.playerId && player.formationPlace) {
              // 过滤没有playerId、playerName、阵容位置的球员，这球员有问题，因此首发阵容不展示
              formatTeams.push(player)
            }
          })
          formatStartLineups.push(formatTeams)
        })

        let formatSubLineups = []
        newVal.subLineups.forEach((teams) => {
          const formatTeams = []
          teams.forEach((player) => {
            if (player.playerEvents) {
              player.playerEvents.forEach((event) => {
                event.eventCodeWeb = this.eventCode2eventCodeWeb(event.type)
              })
            }
            if (player.startPlayer) {
              player.startPlayer.playerEvents.forEach((event) => {
                event.eventCodeWeb = this.eventCode2eventCodeWeb(event.type)
              })
            }
            // if (player.playerId && player.playerName) {
            //   // 过滤没有playerId、playerName的球员，这球员有问题，因此替补阵容不展示有问题的球员，其他正常展示
            //   formatTeams.push(player);
            // }

            if (player.playerId) {
              // 过滤没有playerId、playerName的球员，这球员有问题，因此替补阵容不展示有问题的球员，其他正常展示
              formatTeams.push(player)
            }
          })
          formatSubLineups.push(formatTeams)
        })

        this.isThemeFlagArr = []
        this.tabArr.forEach((tab, tabIndex) => {
          if (tab.act) {
            actTabIndex = tabIndex
            subPlayerList =
              formatSubLineups && formatSubLineups.length == 2
                ? formatSubLineups[tabIndex]
                : []
          }
          console.debug('formatStartLineups:', formatStartLineups)
          startPlayerList =
            formatStartLineups && formatStartLineups.length == 2
              ? formatStartLineups[tabIndex]
              : []
          allStartPlayerList.push(
            this.sortPlayerPosition(
              startPlayerList,
              lineupLayoutMap.opta[tab.name]
            )
          )
        })
        this.allStartPlayerList = allStartPlayerList
        this.formatSubLineups = formatSubLineups
        console.debug(
          'subPlayerList:',
          subPlayerList,
          startPlayerList,
          formatStartLineups
        )
        this.realityRowNum = subPlayerList.length
        this.isShrinkFlag = this.realityRowNum > this.shrinkRowNum
        this.showRowNum =
          this.isShrinkFlag && !this.shrinkTypeFlag
            ? this.shrinkRowNum
            : this.realityRowNum
        this.baseInfor = newVal.matchInfo

        this.startPlayerList =
          this.allStartPlayerList[actTabIndex ? actTabIndex : 0]
        this.subPlayerList = subPlayerList

        subPlayerList = null
        startPlayerList = null
        tabArr = null
        actTabIndex = -1
        allStartPlayerList = null
        formatStartLineups = null
        formatSubLineups = null
        // if(!this.isWatchDataFlag){
        //   this.isWatchDataFlag = true
        // }
      },
      immediate: true,
      // deep: true,
    },
  },
  computed: {
    viewBoxHeight() {
      //   console.debug(112312, this.showRowNum);
      // var shrinkBox = this.isShrinkFlag ? 70 : 20;
      // var heightRem = (shrinkBox + 40 + 90 * this.showRowNum)/100;
      // heightRem = shrinkBox + 5.333 + 13 * this.showRowNum;
      const clientWidth = window.innerWidth || window.screen.width
      const shrinkBox = this.isShrinkFlag ? 0.9 : 0
      let heightRem = 0
      if (clientWidth == 320) {
        heightRem = 14.0625 * this.showRowNum
      } else {
        heightRem = 12 * this.showRowNum
      }

      return `${shrinkBox}rem + ${heightRem}vw`
    },
  },
  methods: {
    // ...mapActions([
    //   'set_isFloatLayer',
    //   'set_parentScrollTopPx',
    //   'set_floatLayerCurPlayer',
    // ]),
    clickTab(item) {
      this.tabArr.forEach((tab, index) => {
        if (item.key == tab.key) {
          tab.act = true
          this.curTabIndex = index
          this.cruCoach = tab.coach ? tab.coach : ''
          this.actLineupType = tab.lineupType ? `lineup_${tab.lineupType}` : ''
        } else {
          tab.act = false
        }
      })

      this.startPlayerList = this.allStartPlayerList[this.curTabIndex]
      this.subPlayerList = this.formatSubLineups[this.curTabIndex]

      this.realityRowNum = this.subPlayerList.length
      this.isShrinkFlag = this.realityRowNum > this.shrinkRowNum
      this.showRowNum =
        this.isShrinkFlag && !this.shrinkTypeFlag
          ? this.shrinkRowNum
          : this.realityRowNum
    },
    sortPlayerPosition(playerArr, lineupArr) {
      console.debug(playerArr, lineupArr)
      const arr = []
      if (
        !playerArr ||
        playerArr.length != 11 ||
        !lineupArr ||
        lineupArr.length != 11
      ) {
        this.isThemeFlagArr.push(false)
        return arr
      }
      lineupArr.forEach((lineup) => {
        playerArr.forEach((player) => {
          if (player.formationPlace == lineup) {
            arr.push(player)
          }
        })
      })
      if (arr.length !== 11) {
        this.isThemeFlagArr.push(false)
      }
      console.debug('isThemeFlagArr:', this.isThemeFlagArr, arr.length)
      return arr
    },
    openFloatLayer(item, state) {
      // console.debug(
      //   "scrollTop:",
      //   window.document.getElementsByClassName("comp-item")[0].scrollTop
      // );
      if (
        state == 'sub' &&
        (!item.startPlayer || !item.startPlayer.playerName)
      ) {
        return
      }

      const scrollTop = document.scrollingElement.scrollTop
      document.body.classList.add('modalOpen')
      document.body.style.top = `-${scrollTop}px`
      console.debug(scrollTop)
      //   this.set_parentScrollTopPx(scrollTop)
      //   this.set_floatLayerCurPlayer(item)
      //   this.set_isFloatLayer(true)
    },
    _valFormatHandler(val) {
      var data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '-'
      } else {
        data = val
      }
      // console.debug(val, data)
      return data
    },
    shrinkTypeHandler() {
      console.debug(this.showRowNum, this.realityRowNum, this.shrinkRowNum)
      this.shrinkTypeFlag = !this.shrinkTypeFlag
      if (this.shrinkTypeFlag) {
        this.showRowNum = this.realityRowNum
        this.shrinkText = '收起'
      } else {
        this.shrinkText = '展开'
        this.showRowNum = this.shrinkRowNum
      }
      console.debug(this.showRowNum)
    },
    eventCode2eventCodeWeb(num) {
      //后端code to 前端code
      let key = null
      switch (num) {
        case 1:
          key = 1
          break
        case 2:
          key = 0
          break
        case 3:
          key = 2
          break
        case 5:
          key = 4
          break
        case 6:
          key = 5
          break
        case 4:
          key = 6
          break
        case 9:
          key = 3
          break
        case 0:
          key = 7
          break
        default:
          key = null
          break
      }
      return key
    },
    eventCodeWeb2eventKey(num) {
      let key = ''
      switch (num) {
        case 0:
          key = 'point'
          break
        case 1:
          key = 'goal'
          break
        case 2:
          key = 'ownGoal'
          break
        case 3:
          key = 'offStage'
          break
        case 4:
          key = 'yellowCard'
          break
        case 5:
          key = 'redCard'
          break
        case 6:
          key = 'onStage'
          break
        default:
          key = null
          break
      }
      return key
    },
  },
}
</script>

<style lang="scss" scoped>
.MATCHLINEUP {
  width: 100%;
  height: auto;
  background-color: #1c1e23;
  padding-bottom: 20px;
  .matchLineup_title {
    width: 100%;
    height: 72px;
    padding: 0 2.6%;
    font-size: 30px;
    color: #fff;
    font-weight: bold;
    line-height: 72px;
  }
  .btnArea {
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 80px;
    color: #fff;
    .tabBtns {
      display: block;
      width: 420px;
      background-color: rgba(255, 255, 255, 0.12);
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      .teamLineup {
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        width: 210px;
        height: 64px;

        border-radius: 8px;
        &.act {
          background-color: #0057fe;
        }
        .teamLogo {
          width: 44px;
          height: 44px;
          overflow: hidden;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .lineupType {
          padding-left: 10px;
          font-size: 26px;
          line-height: 64px;
          font-weight: bold;
          text-align: center;
        }
      }
    }
  }

  .startLineupBox {
    padding: 14px 2.6% 40px 2.6%;
    width: 100%;
    .startLineup_title {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 72px;
      font-weight: bold;
      .title {
        color: #fff;
        font-size: 30px;
        font-weight: bold;
      }
      .coachName {
        color: rgba(255, 255, 255, 0.5);
        font-size: 18px;
      }
    }
    .footballField_container {
      position: relative;
      width: 100%;
      height: 592px;
      background-size: 100% 100%;
      background-position: left top;
      background-repeat: no-repeat;
      background-image: url('data:image/png;base64,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');
      .playerItem {
        position: absolute;
        z-index: 50;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: column;
        width: 110px;
        height: 84px;
        color: #fff;
        transition: all 0.3s linear;
        .playerLogo {
          position: relative;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
          .defautlPlayerImg {
            display: block;
            width: 100%;
            height: 100%;
            background-size: 100% 100%;
            background-position: center;
            background-repeat: no-repeat;
            background-image: url('data:image/png;base64,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');
          }
          .playerNum {
            position: absolute;
            bottom: 0;
            left: 0;
            z-index: 2;
            margin-left: -15px;
            padding-top: 6px;
            width: 34px;
            height: 34px;
            font-size: 20px;
            font-family: 'DINCondensed-Bold';
            text-align: center;
            background-color: #e42c5f;
            border-radius: 50%;
            // background-size: 100% 100%;
            // background-repeat: no-repeat;
            // background-position: center;
            // background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAADUklEQVRoBe1aTUwTQRSeN+0WBA1ejDFeRGNsrW2JJsabiTePGo2VH09qPEhARAU1Wo0RVEQIntST/Fij0aM3iTdjYgKtFYxRvBhjuEgUBJbu+GaxcbvZbZfObgGzvXTn/X7vvZk5vDdAHPoNh2u3EFnuVM1LUlMk0ffBCVdgt9FPO45XTP6euKQwUk8Yk1T7ADIF0lO+ouLqprf3Juz0aVsALBajyfjoUYUo1xDgGhOQ45TQi6Go/wHEYoqJzILItgSQ8B/erUC6izBSZck7kCHKPI3h0UevLMnnEBIKYKQqumF2ht1kjB3M4cOUBQBPfCVwNjAU/2IqlIdRUADD4bpyJsstwFgzI6w0j4+cbCAwzQA6QJLaI4neyZzCBswFBYCZhmQwWq0o7AbaWm9gT4T0lVI4F0rFB7AyzKohywGkgtU755R0Nwaxy6rxQuQQ/Gsv9TQEUwNvrOjnDeB9oHadTGbb8IAewbTklbfiNJ8MOmHo6aFEfK1bR/q+5ZI3BfRxb33J1Nj3JjR0njGyMpcRp3gA5BeGcr2scm3n5hc9M0Z+DANIBqL7FMY68IBuNFIqNg0P+mcK0BwaiT/X+84KIBGqCeHt0oVbZY9ecCmsEexLvK0aw8n+ZAYPzXzwfzY3d3+pglfxYWI5Ri3mrAC0jOXy7Qaw2JVyK+BWQDAD7hYSTKCwulsB4RQKGnArIJhAYXW3AsIpFDTgVkAwgcLqbgWEUyhowK2AYAKF1d0KCKdQ0MD/VQHweo9h+3NQMCkOqsPgPMZ/LrI6cxnykP/QfiC8tUgqM7TF/EeQY9jtba4affxMj8NwC3FBbKgGgNILaoNVr1WkNffNMXAsRuA5DMMKaPHNt9fldpw41mFF8sprdQv9RieYcOiViNRScHtd73zZDji0gfAR07tgdU1aSbcj3fYRk4d6WralBvodGTFpA+FDPiLPtmKhT9sx5MONeZtIvjbHh3zaIPi3OmadVm7h2Tig51lZ415/6iulZ4o+ZtWDUwfdROnGsxfR84zXMIwT+wY7Bt2G16ixU3MqBxKJBrbjmPQESo2bS5JxLsNl7QDP/dh+LfLHHj+nflxG0ye1jz2wOndXla2+smQfe+iz/ve5zR2VLkmnnHpu8wdttAstUoTIfwAAAABJRU5ErkJggg==");
          }
          .playerEvents {
            position: absolute;
            top: 0;
            right: -60px;
            z-index: 2;
            width: 78px;
            height: 56px;
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            .eventTop,
            .eventBottom {
              width: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: flex-start;
              height: 22px;
              .eventItem {
                display: flex;
                display: -webkit-flex;
                justify-content: center;
                align-items: center;
                background-color: rgba(0, 0, 0, 0.5);
                width: 22px;
                height: 22px;
                border-radius: 50%;
                margin-left: 2px;
                &:first-child {
                  margin-left: 0;
                }
                &::before {
                  content: '\20';
                  width: 16px;
                  height: 16px;
                  background-size: 100% 100%;
                  background-position: center;
                  background-repeat: no-repeat;
                }
                &.point::before {
                  background-image: url('data:image/png;base64,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');
                }
                &.goal::before {
                  background-image: url('data:image/png;base64,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');
                }
                &.ownGoal::before {
                  background-image: url('data:image/png;base64,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');
                }

                &.offStage::before {
                  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACiElEQVRoBe1ZPYgTQRSeNzF6HMbdRbCMv2BhYWEvKAcWJ4KVFt6PhcoJh4UcIqIcIiIixyF3HOLPmd1gqZ2FIKJY2FjaXXQ3CoIIJka84zB5zisW9tTdnezbYIqZZmbevPe+731vshsSIcwwCrAUAFZ0JPhb+QRGtqlLp17NBVumIvW5gyngfzfIdMB0gKmAuUJMAdnhpgNsCZkJTAeYArLDTQfYEjITmA4wBWSHmw6wJWQmMB1gCsgONx1gS8hMkPjTxvKO0fJKBw9qYXRwUcsvdJJwMlwmzRsK654P1hY/xvkkFoDT07L5oPYIBR6LS9BLOwDct3z3lJpjf3NKLIDI4b7TxcbX5ccC8XAvyf6ZW5G+q8ifSSJPMakFkBNuGx9oYvspIh6gfa+HInXHCryJNPLEQ+spBP7DFWtj6QiAeNNz8iAXdMkTF60OhKQb5QkH4ccLdZ32hrZcZ4B523cndZQPcbsqgIJaO0e2tH/hK0SxO0ySywxyzgncyW5zaV2haNJSzfuyvjgwpFTyo3bWWsLtLOQJs+sCKGhw6d4nUZRD6gJ+pj1nSAGzju+dy5qj6ysUBWrtGtvTXu28VO+JzVG77lqCmLGC6nld/3/5ZepAmKi0VHmnmnhIdeJ7aNOdAeQtLnnCYhVACex65W2hIIfVA+0n7XUGSLhpB+6Ujm+aD7sAAtj03n0NBXlUvSdW0wBBwA3b9y6k+eme51IAgdkfKs9QyOPqQ9WOA1cFXrfr3sW48yz23AogcPUofAJCjqsi/v7yBXDNDqqXspBMism1AAKy6m5VSDi7BlTCVSfwLq+x9fumsXV0iv56bZZHrvQ711h+re1j+2MPzYFRwCiQiwK/AW6dkE1GMlycAAAAAElFTkSuQmCC');
                }
                &.yellowCard::before,
                &.redCard::before {
                  display: none;
                }
                &.yellowCard::after,
                &.redCard::after {
                  content: '\20';
                  width: 12px;
                  height: 16px;
                }
                &.yellowCard::after {
                  background-color: #f4e336;
                }
                &.redCard::after {
                  background-color: #c80505;
                }
              }
            }
            .eventBottom {
              padding-top: 8px;
            }
          }
        }
        .playerName {
          width: 100%;
          font-size: 20px;
          line-height: 24px;
          font-weight: bold;
          text-align: center;
          overflow: hidden;
        }
      }
      &.lineup_442 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 184px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 184px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 184px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 184px;
          }
          &:nth-child(6) {
            left: 60px;
            bottom: 306px;
          }
          &:nth-child(7) {
            left: 205px;
            bottom: 306px;
          }
          &:nth-child(8) {
            right: 205px;
            bottom: 306px;
          }
          &:nth-child(9) {
            right: 60px;
            bottom: 306px;
          }
          &:nth-child(10) {
            left: 191px;
            bottom: 430px;
          }
          &:nth-child(11) {
            right: 191px;
            bottom: 430px;
          }
        }
      }
      &.lineup_41212 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 126px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 126px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 126px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 126px;
          }
          &:nth-child(6) {
            left: 50%;
            bottom: 216px;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            left: 205px;
            bottom: 306px;
          }
          &:nth-child(8) {
            right: 205px;
            bottom: 306px;
          }
          &:nth-child(9) {
            left: 50%;
            bottom: 396px;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            left: 205px;
            bottom: 486px;
          }
          &:nth-child(11) {
            right: 205px;
            bottom: 486px;
          }
        }
      }
      &.lineup_433 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 184px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 184px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 184px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 184px;
          }
          &:nth-child(6) {
            left: 164px;
            bottom: 306px;
          }
          &:nth-child(7) {
            left: 50%;
            bottom: 306px;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            right: 164px;
            bottom: 306px;
          }
          &:nth-child(9) {
            left: 164px;
            bottom: 430px;
          }
          &:nth-child(10) {
            left: 50%;
            bottom: 430px;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            right: 164px;
            bottom: 430px;
          }
        }
      }
      &.lineup_451 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 60px;
            bottom: 184px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 184px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 184px;
          }
          &:nth-child(5) {
            right: 60px;
            bottom: 184px;
          }
          &:nth-child(6) {
            left: 40px;
            bottom: 306px;
          }
          &:nth-child(7) {
            left: 154px;
            bottom: 306px;
          }
          &:nth-child(8) {
            left: 50%;
            bottom: 306px;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            right: 154px;
            bottom: 306px;
          }
          &:nth-child(10) {
            right: 40px;
            bottom: 306px;
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 430px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_4411 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 140px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 140px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 140px;
          }
          &:nth-child(6) {
            left: 60px;
            bottom: 244px;
          }
          &:nth-child(7) {
            left: 212px;
            bottom: 244px;
          }
          &:nth-child(8) {
            right: 212px;
            bottom: 244px;
          }
          &:nth-child(9) {
            right: 60px;
            bottom: 244px;
          }
          &:nth-child(10) {
            left: 50%;
            bottom: 348px;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 452px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_4141 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 140px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 140px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 140px;
          }
          &:nth-child(6) {
            left: 50%;
            bottom: 244px;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            left: 80px;
            bottom: 348px;
          }
          &:nth-child(8) {
            left: 219px;
            bottom: 348px;
          }
          &:nth-child(9) {
            right: 219px;
            bottom: 348px;
          }
          &:nth-child(10) {
            right: 80px;
            bottom: 348px;
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 452px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_4231 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 140px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 140px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 140px;
          }
          &:nth-child(6) {
            left: 212px;
            bottom: 244px;
          }
          &:nth-child(7) {
            right: 212px;
            bottom: 244px;
          }
          &:nth-child(8) {
            left: 159px;
            bottom: 348px;
          }
          &:nth-child(9) {
            left: 50%;
            bottom: 348px;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            right: 159px;
            bottom: 348px;
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 452px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_4321 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 140px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 140px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 140px;
          }
          &:nth-child(6) {
            left: 164px;
            bottom: 244px;
          }
          &:nth-child(7) {
            left: 50%;
            bottom: 244px;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            right: 164px;
            bottom: 244px;
          }
          &:nth-child(9) {
            left: 219px;
            bottom: 348px;
          }
          &:nth-child(10) {
            right: 219px;
            bottom: 348px;
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 452px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_532 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 30px;
            bottom: 184px;
          }
          &:nth-child(3) {
            left: 159px;
            bottom: 184px;
          }
          &:nth-child(4) {
            left: 50%;
            bottom: 184px;
            transform: translateX(-50%);
          }
          &:nth-child(5) {
            right: 159px;
            bottom: 184px;
          }
          &:nth-child(6) {
            right: 30px;
            bottom: 184px;
          }
          &:nth-child(7) {
            left: 164px;
            bottom: 306px;
          }
          &:nth-child(8) {
            left: 50%;
            bottom: 306px;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            right: 164px;
            bottom: 306px;
          }
          &:nth-child(10) {
            left: 225px;
            bottom: 430px;
          }
          &:nth-child(11) {
            right: 225px;
            bottom: 430px;
          }
        }
      }
      &.lineup_541 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 30px;
            bottom: 184px;
          }
          &:nth-child(3) {
            left: 159px;
            bottom: 184px;
          }
          &:nth-child(4) {
            left: 50%;
            bottom: 184px;
            transform: translateX(-50%);
          }
          &:nth-child(5) {
            right: 159px;
            bottom: 184px;
          }
          &:nth-child(6) {
            right: 30px;
            bottom: 184px;
          }
          &:nth-child(7) {
            left: 60px;
            bottom: 306px;
          }
          &:nth-child(8) {
            left: 212px;
            bottom: 306px;
          }
          &:nth-child(9) {
            right: 212px;
            bottom: 306px;
          }
          &:nth-child(10) {
            right: 60px;
            bottom: 306px;
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 430px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_352 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 159px;
            bottom: 184px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 184px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 159px;
            bottom: 184px;
          }
          &:nth-child(5) {
            left: 40px;
            bottom: 306px;
          }
          &:nth-child(6) {
            left: 164px;
            bottom: 306px;
          }
          &:nth-child(7) {
            left: 50%;
            bottom: 306px;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            right: 164px;
            bottom: 306px;
          }
          &:nth-child(9) {
            right: 40px;
            bottom: 306px;
          }
          &:nth-child(10) {
            left: 225px;
            bottom: 430px;
          }
          &:nth-child(11) {
            right: 225px;
            bottom: 430px;
          }
        }
      }
      &.lineup_343 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 159px;
            bottom: 184px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 184px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 159px;
            bottom: 184px;
          }
          &:nth-child(5) {
            left: 50px;
            bottom: 306px;
          }
          &:nth-child(6) {
            left: 212px;
            bottom: 306px;
          }
          &:nth-child(7) {
            right: 212px;
            bottom: 306px;
          }
          &:nth-child(8) {
            right: 50px;
            bottom: 306px;
          }
          &:nth-child(9) {
            left: 164px;
            bottom: 430px;
          }
          &:nth-child(10) {
            left: 50%;
            bottom: 430px;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            right: 164px;
            bottom: 430px;
          }
        }
      }
      &.lineup_31312 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 156px;
            bottom: 126px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 126px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 156px;
            bottom: 126px;
          }
          &:nth-child(5) {
            left: 50%;
            bottom: 216px;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            left: 166px;
            bottom: 306px;
          }
          &:nth-child(7) {
            left: 50%;
            bottom: 306px;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            right: 166px;
            bottom: 306px;
          }
          &:nth-child(9) {
            left: 50%;
            bottom: 396px;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            left: 232px;
            bottom: 486px;
          }
          &:nth-child(11) {
            right: 232px;
            bottom: 486px;
          }
        }
      }
      &.lineup_4222 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 140px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 140px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 140px;
          }
          &:nth-child(6) {
            left: 212px;
            bottom: 244px;
          }
          &:nth-child(7) {
            right: 212px;
            bottom: 244px;
          }
          &:nth-child(8) {
            left: 219px;
            bottom: 348px;
          }
          &:nth-child(9) {
            right: 219px;
            bottom: 348px;
          }
          &:nth-child(10) {
            left: 225px;
            bottom: 452px;
          }
          &:nth-child(11) {
            right: 225px;
            bottom: 452px;
          }
        }
      }
      &.lineup_3511 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 159px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 140px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 159px;
            bottom: 140px;
          }
          &:nth-child(5) {
            left: 40px;
            bottom: 244px;
          }
          &:nth-child(6) {
            left: 164px;
            bottom: 244px;
          }
          &:nth-child(7) {
            left: 50%;
            bottom: 244px;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            right: 164px;
            bottom: 244px;
          }
          &:nth-child(9) {
            right: 40px;
            bottom: 244px;
          }
          &:nth-child(10) {
            left: 50%;
            bottom: 348px;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 452px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_3421 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 159px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 140px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 159px;
            bottom: 140px;
          }
          &:nth-child(5) {
            left: 60px;
            bottom: 244px;
          }
          &:nth-child(6) {
            left: 212px;
            bottom: 244px;
          }
          &:nth-child(7) {
            right: 212px;
            bottom: 244px;
          }
          &:nth-child(8) {
            right: 60px;
            bottom: 244px;
          }
          &:nth-child(9) {
            left: 219px;
            bottom: 348px;
          }
          &:nth-child(10) {
            right: 219px;
            bottom: 348px;
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 452px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_3412 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 159px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 140px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 159px;
            bottom: 140px;
          }
          &:nth-child(5) {
            left: 60px;
            bottom: 244px;
          }
          &:nth-child(6) {
            left: 212px;
            bottom: 244px;
          }
          &:nth-child(7) {
            right: 212px;
            bottom: 244px;
          }
          &:nth-child(8) {
            right: 60px;
            bottom: 244px;
          }
          &:nth-child(9) {
            left: 50%;
            bottom: 348px;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            left: 225px;
            bottom: 452px;
          }
          &:nth-child(11) {
            right: 225px;
            bottom: 452px;
          }
        }
      }
      &.lineup_3142 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 159px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 140px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 159px;
            bottom: 140px;
          }
          &:nth-child(5) {
            left: 50%;
            bottom: 244px;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            left: 80px;
            bottom: 348px;
          }
          &:nth-child(7) {
            left: 219px;
            bottom: 348px;
          }
          &:nth-child(8) {
            right: 219px;
            bottom: 348px;
          }
          &:nth-child(9) {
            right: 80px;
            bottom: 348px;
          }

          &:nth-child(10) {
            left: 225px;
            bottom: 452px;
          }
          &:nth-child(11) {
            right: 225px;
            bottom: 452px;
          }
        }
      }
      &.lineup_343d {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 156px;
            bottom: 126px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 126px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 156px;
            bottom: 126px;
          }
          &:nth-child(5) {
            left: 50%;
            bottom: 216px;
            transform: translateX(-50%);
          }
          &:nth-child(6) {
            left: 44px;
            bottom: 306px;
          }
          &:nth-child(7) {
            right: 44px;
            bottom: 306px;
          }
          &:nth-child(8) {
            left: 50%;
            bottom: 396px;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            left: 178px;
            bottom: 486px;
          }

          &:nth-child(10) {
            left: 50%;
            bottom: 486px;
            transform: translateX(-50%);
          }
          &:nth-child(11) {
            right: 178px;
            bottom: 486px;
          }
        }
      }
      &.lineup_4132 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 140px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 140px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 140px;
          }
          &:nth-child(6) {
            left: 50%;
            bottom: 244px;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            left: 159px;
            bottom: 348px;
          }
          &:nth-child(8) {
            left: 50%;
            bottom: 348px;
            transform: translateX(-50%);
          }
          &:nth-child(9) {
            right: 159px;
            bottom: 348px;
          }
          &:nth-child(10) {
            left: 225px;
            bottom: 452px;
          }
          &:nth-child(11) {
            right: 225px;
            bottom: 452px;
          }
        }
      }
      &.lineup_4240 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 60px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 184px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 184px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 184px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 184px;
          }
          &:nth-child(6) {
            left: 212px;
            bottom: 306px;
          }
          &:nth-child(7) {
            right: 211px;
            bottom: 306px;
          }
          &:nth-child(8) {
            left: 100px;
            bottom: 430px;
          }
          &:nth-child(9) {
            left: 225px;
            bottom: 430px;
          }
          &:nth-child(10) {
            right: 225px;
            bottom: 430px;
          }
          &:nth-child(11) {
            right: 100px;
            bottom: 430px;
          }
        }
      }
      &.lineup_4312 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 40px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 205px;
            bottom: 140px;
          }
          &:nth-child(4) {
            right: 205px;
            bottom: 140px;
          }
          &:nth-child(5) {
            right: 40px;
            bottom: 140px;
          }
          &:nth-child(6) {
            left: 164px;
            bottom: 244px;
          }
          &:nth-child(7) {
            left: 50%;
            bottom: 244px;
            transform: translateX(-50%);
          }
          &:nth-child(8) {
            right: 164px;
            bottom: 244px;
          }
          &:nth-child(9) {
            left: 50%;
            bottom: 348px;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            left: 225px;
            bottom: 452px;
          }
          &:nth-child(11) {
            right: 225px;
            bottom: 452px;
          }
        }
      }
      &.lineup_3241 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 159px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 140px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 159px;
            bottom: 140px;
          }
          &:nth-child(5) {
            left: 212px;
            bottom: 244px;
          }
          &:nth-child(6) {
            right: 212px;
            bottom: 244px;
          }

          &:nth-child(7) {
            left: 80px;
            bottom: 348px;
          }
          &:nth-child(8) {
            left: 219px;
            bottom: 348px;
          }
          &:nth-child(9) {
            right: 219px;
            bottom: 348px;
          }
          &:nth-child(10) {
            right: 80px;
            bottom: 348px;
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 452px;
            transform: translateX(-50%);
          }
        }
      }
      &.lineup_3331 {
        .playerItem {
          &:first-child {
            left: 50%;
            bottom: 36px;
            transform: translateX(-50%);
          }
          &:nth-child(2) {
            left: 159px;
            bottom: 140px;
          }
          &:nth-child(3) {
            left: 50%;
            bottom: 140px;
            transform: translateX(-50%);
          }
          &:nth-child(4) {
            right: 159px;
            bottom: 140px;
          }
          &:nth-child(5) {
            left: 164px;
            bottom: 244px;
          }
          &:nth-child(6) {
            left: 50%;
            bottom: 244px;
            transform: translateX(-50%);
          }
          &:nth-child(7) {
            right: 164px;
            bottom: 244px;
          }

          &:nth-child(8) {
            left: 159px;
            bottom: 348px;
          }
          &:nth-child(9) {
            left: 50%;
            bottom: 348px;
            transform: translateX(-50%);
          }
          &:nth-child(10) {
            right: 159px;
            bottom: 348px;
          }
          &:nth-child(11) {
            left: 50%;
            bottom: 452px;
            transform: translateX(-50%);
          }
        }
      }
    }
  }
  .subLineupBox {
    padding: 0 2.6% 20px 2.6%;
    width: 100%;
    .subLineup_title {
      width: 100%;
      height: 72px;
      padding: 0 2.6%;
      font-size: 30px;
      color: #fff;
      font-weight: bold;
      line-height: 72px;
    }
    .viewBox {
      position: relative;
      transition: height 0.3s ease-in-out;
      height: 0;
      overflow: hidden;
      .tableUl {
        padding: 0 0.2rem;
        width: 100%;
        height: auto;
        box-sizing: border-box;
        .itemRow {
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;
          height: 90px;
          transition: opacity 0.1s linear 0.2s;
          border-top: 1px solid #333;
          &:last-child {
            border-bottom: 1px solid #333;
          }
          .leftPlayerItem {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 60%;
            height: 60px;
            color: #fff;
            .playerLogo {
              position: relative;
              width: 50px;
              height: 50px;
              border-radius: 50%;
              img {
                display: block;
                width: 100%;
                height: 100%;
                object-fit: contain;
              }
              .defautlPlayerImg {
                display: block;
                width: 100%;
                height: 100%;
                background-size: 100% 100%;
                background-position: center;
                background-repeat: no-repeat;
                background-image: url('data:image/png;base64,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');
              }
              .playerNum {
                position: absolute;
                bottom: 0;
                right: 0;
                z-index: 2;
                width: 26px;
                height: 26px;
                margin-right: -13px;
                border-radius: 50%;
                font-size: 14px;
                line-height: 26px;
                color: #fff;
                text-align: center;
                font-weight: bold;
                background-color: #d02856;
              }
            }
            .inforRow {
              padding: 0 4px 0 16px;
              width: calc(100% - 64px);
            }
          }
          .rightPlayerItem {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: center;
            width: 40%;
            height: 60px;
            color: #fff;
            .inforRow {
              width: 100%;
            }
          }
          .inforRow {
            display: flex;
            display: -webkit-flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-direction: column;
            .inforRow_1 {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              color: #fff;
              .playerName {
                width: 190px;
                padding-right: 10px;
                font-size: 24px;
                line-height: 33px;
                font-weight: bold;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .playerPos,
              .playerGrade {
                width: auto;
                padding: 2px 6px;
                background-color: rgba(255, 255, 255, 0.3);
                font-size: 20px;
                line-height: 20px;
              }
              .playerGrade {
                margin-left: 4px;
              }
            }
            .inforRow_2 {
              display: flex;
              display: -webkit-flex;
              justify-content: flex-start;
              align-items: center;
              color: #fff;
              & > span {
                margin-left: 10px;
                &:first-child {
                  margin-left: 0;
                }
              }
              .onStage,
              .offStage {
                position: relative;
                font-size: 20px;
                line-height: 28px;
                padding-left: 22px;
                &::before {
                  content: '\20';
                  position: absolute;
                  top: 3px;
                  left: 0;
                  z-index: 2;
                  width: 22px;
                  height: 22px;
                  background-position: center;
                  background-size: 100% 100%;
                  background-repeat: no-repeat;
                }
              }
              .onStage {
                &::before {
                  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACdklEQVRoBe1WTWjUQBR+E3UR8eAPeNkktLvHInbtVRA9ePLi3av4hyioKCJSERGFFhSKFG967FEUREXF+25W6XE3bncLxVM9CW3zni9gD53dJpNJMqBMLuG9efO+731fMgmAvawCVoHSFHCb4fHSmv9t7JQF4La6NwnwMw9xryyMuK8oo7kXhBcQ8flmbyHg/qBRn96Mi7wXPoAbdM8SwUsg2trbEQ+WJ2uFu7EVJKc0bvDjDCEuANCOka2EeLjcqN0duaaZLGwAL+ieIqLXrH4liYsjnEf9xvidpJosa4UM4AedYxGKd6z8HhVwBn08OFq/rVKbVpP7FPK/9aYQ4Y0q+ZgQAdziU+pJGjmV9VwO+EFvIsLoC1M6qAI2VOOIGX6xbwzlMyS0HfC+L9URo/fa5GOSSNe9Vjibge9QqZYD1fbABVz7ykfl2FBHjQR/J57yd+KaxlbI7EC9vXKIyX8oinxMmk+uq26z+0xngEwO8Au7H6PoEx+XR3TA0vYIIeb6k+NX+M7vudql7MDE4s+9uBG9LYt8TJd7X+Yv+RzflYVVKhwLw90bq8jk4YSaLvmqWNX5pUbtoooTqQ5MEe1aX6UFU+Tj0RHgPP8Qzqs4kTjANJGz0gpfsben82mafTeTP+e1wxdpQyQ+QrXFjr++5pxUgSegGQY7oFIrQPzmx+OSSm1lZ+Vj53C1v11t4gDbbRqVrzY7Pc77o9bkHIP+4n+hfXJeJ058hHQamt5jBzCtuIxnHZAVMR1bB0wrLuNZB2RFTMfWAdOKy3jWAVkR07F1wLTiMp51QFbEdGwdMK24jGcdkBUxHf/zDpgWzOL9dwr8ARaTw1dCUaj9AAAAAElFTkSuQmCC');
                }
              }
              .offStage {
                &::before {
                  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAACiElEQVRoBe1ZPYgTQRSeNzF6HMbdRbCMv2BhYWEvKAcWJ4KVFt6PhcoJh4UcIqIcIiIixyF3HOLPmd1gqZ2FIKJY2FjaXXQ3CoIIJka84zB5zisW9tTdnezbYIqZZmbevPe+731vshsSIcwwCrAUAFZ0JPhb+QRGtqlLp17NBVumIvW5gyngfzfIdMB0gKmAuUJMAdnhpgNsCZkJTAeYArLDTQfYEjITmA4wBWSHmw6wJWQmMB1gCsgONx1gS8hMkPjTxvKO0fJKBw9qYXRwUcsvdJJwMlwmzRsK654P1hY/xvkkFoDT07L5oPYIBR6LS9BLOwDct3z3lJpjf3NKLIDI4b7TxcbX5ccC8XAvyf6ZW5G+q8ifSSJPMakFkBNuGx9oYvspIh6gfa+HInXHCryJNPLEQ+spBP7DFWtj6QiAeNNz8iAXdMkTF60OhKQb5QkH4ccLdZ32hrZcZ4B523cndZQPcbsqgIJaO0e2tH/hK0SxO0ySywxyzgncyW5zaV2haNJSzfuyvjgwpFTyo3bWWsLtLOQJs+sCKGhw6d4nUZRD6gJ+pj1nSAGzju+dy5qj6ysUBWrtGtvTXu28VO+JzVG77lqCmLGC6nld/3/5ZepAmKi0VHmnmnhIdeJ7aNOdAeQtLnnCYhVACex65W2hIIfVA+0n7XUGSLhpB+6Ujm+aD7sAAtj03n0NBXlUvSdW0wBBwA3b9y6k+eme51IAgdkfKs9QyOPqQ9WOA1cFXrfr3sW48yz23AogcPUofAJCjqsi/v7yBXDNDqqXspBMism1AAKy6m5VSDi7BlTCVSfwLq+x9fumsXV0iv56bZZHrvQ711h+re1j+2MPzYFRwCiQiwK/AW6dkE1GMlycAAAAAElFTkSuQmCC');
                }
              }
              .point,
              .goal,
              .ownGoal {
                width: 22px;
                height: 22px;
                background-position: center;
                background-size: 100% 100%;
                background-repeat: no-repeat;
              }
              .goal {
                background-image: url('data:image/png;base64,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');
              }
              .ownGoal {
                background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAMKADAAQAAAABAAAAMAAAAADbN2wMAAAJXUlEQVRoBe1ZfWxcRxHfee++/Hl3UVMaoMQfiUmaJqEJ+SpKWye2SyIKakVCISgFIRBVG1XqH61EUmoh4I+AKtKKqFKlqhChigYBaikpsV23JEBRKxEEceI4/kppYpO292U7vrt3u/zmfM/37t177y4fIP7ISvbbnZmdndmdmZ2dE+J6u74DV7UDdFWzXSYr1a3NHPvlR7JG5qNCkfL7/RdqN39pkqhbuky5YvA1UWCqf8VNhjF7jxLq82B4E0mhSRKzRCpLgjSpRBD9EBFl0b8A2Ms+X+iV+vaTE1cseWHiVSkQ62m5j0g8IqSCgCKjBC1XSt3gJRQW/EARjeNkSNdlMifp6WjnyK+95njhrkiBZG/zZinp+4LotFBqIXb+Xq9FXHGkBjRN7yMhVwlJ+xo7R4670rogLksB1X9XKJ4df5Y0LVyjZfcFt5w7GetpHhNKLHbhXxHs0313YhPel1I9JoUUEf/ib1P7G7MVJxYItGoJp/+4fFHcONej6XQivHXNF1l4nquR+BFsOl0tHysd5v2m/mPa30iEPtC1msc1Xe/DBv2B17LSefWrOoGp19tWGznjBbjj/vDWsRftDOO9bS1CGj+u1pTgL6eItEfDHcOvMa93X9pUE12QauS+VJmlUhhP4WS+Wb/lzN8Z5tUqKsC7kU3Pvko6PRHeMvKqF7NYb2s7zOEn+FvlRIfFYjC/7kb95oMwE8NKM/T7bcFFgXcjDJN6JioN4+f+YPALdXecumCls/c9TYhtPpNOv4SIcVrmRBsijKfC0Y7h/kjH2jUwjQcRMt83F8OkHMYHNS24FLv+tF14plu6/Ui6rrYhyf1AQGZB/0omk/4Vy8Awt+YpUOxo8wsg+KQSYiMz0Ig+F+70PgVzoVj/pyLCSN6HcVj3+Y40tp85beK8vuqtDY3x1MWDOMVdmkZvw7kHol2jX3Ob43oCHCoFiRZTeGaAOL/JjZEdHm0/EYeDh0ioncrIrbfjXccb3kqRUp9hPIRfh01rycviMsFVASkQ55VYUjJPqeoFwUQl1V1KiY1SyYUlfDwGqb7lC7BpTSYJzHY1LPeH5tj+dVSAb1gcIectpeGM1LpKfmBdAJft7TzWif5qhXv1lcius+KhDKKTUnmZrIhC3+cAwwUrHoHWq9lorA27GUn1L2sDbNAK536st4VTir3wmSkhcEOjoX8ezM5LofbFj7ZgQ9QycKyHM/0g2jFygGnKmiw/ZU5RSCFlEaIs5ShTIJ+YZWeCIA6XMQegYM9lCiBjQ/wWSCsEzEU181wobGnFAdNaECVdJIHrbfsGPpxfaQ0smz0BLFOAs8p8YlZcz7ZAfocOlQAxII1GcAK862O4pJ6y43kMq3wUbJvytE4EgGGn1zstjWzWYNlA8px1apkCnBKDzXIsZ6Wz9OVKy2C+i902U+PJcOfwM/MISyd+tHkXhk0WWgtWiJk3W29Op10dvnlOtlIFypwYO7Bo7shKeM8PSNHF+cE17kgZyrqxZJkQlkuDCohLFFBqhw4FYAXODTdshjSx3xlbGYqo9Bqc+hcwsVEn6rx9E/3OCccwhGUfv/as+BITmjn2zxv5JWUlKPYpiXh4b3jr8NtF2OX18HDprjQj0qDtSqTkb7Hj7eW0NMtPVcDn86MSBfgNC2fJlEYPeASJCeXTt0Xah06UM52D4OlbX3CbukRfc8ULT1divL5jdNLOjzaeTaqhJdsSo7lD8MIdVjwHl/w7200BfoDDgnSrAyOpGhIB/93ROwcdj91cAO/gVez2+LtV5UTFiwvmxCfpqCgtPZuGqdwf7z00Cbt52FwDX2QmMHJLKzkBrh4YmdkQomG+Qfh39KC2veGOwYqOqzQxAyX49s7hLzXHwfF/COxr5dxN70jAwEIFY0+ipzWBVGQvw7g4EICM3DdbicOygyR6f3YcWurQdTjsq/kWtZ/EzXrtWqKn5UkI383ODJ/4qhdn+AFN9628MatmvgxB98N7TzV07L7NWp4p8WhGwIRyka6RDZHOka9ca+G9hHXCHT68My+fn2pfDPnoFrxGklbheU6JCRWYxOPHVkYjm/8Rc2Jqh8V7Wx9D3vu4He441vVO0DqinIA7Fl70T7NBoqWzAZKUjs+Niv/LFECsf1nNTnOZ5PkimXsPbl8DkRa4UxQxmshhvRKrLSIdejEjFQwUyHMi26VBNjtZmQJcMcsaM8+CsCoFfMr/nKFnjtgZO40bb2g4mfz31DYnnB3G9j91dHVQICbONXm3Dz5pjsxvmQJ8G8Z7msOqf0V9NT5Q1zV4Hsz4r6oGJ66KThzZHqAArlU0XTdqNKUa7Jko48oUYCAc+ZlE9tJ31Dtrn4zHY3sQeQMIqWOITmO+oH+8dvPABMYl8ZjnXW1TPS3had3XJA25OEVDt+AUpnSqOZw2sg+xTE78XQ0Sp9CvkzxsSO2n9om4EZFu0Dnkx2O4kP5CoboD1Tq9ySvx5xUL1PTMg+DzafBpgmtwlpovq5g0+a+ufZ2kfCDSOdpeAi8MHE+Accj8vquU9j2nSVgIpQ7VBlwbFu8Ss9P34Pq/nW9QJ3o7jM0zPnXpTcBvzd/dTOByniTVbjjvE3Ye5rjkHjCB/G3sGD2WQ76CneGFPBuOek1qXN3vSWRBJrOXvgGJIXylRn8C73NeRV9XBZg1F1pxxIgDdKbSUiiB7KlEw3iOLriQHqqC9iw2T83J4E7tqQBXiQPB4E4wYpv/lzsbtgC1NtnXmq9CeNElX1/yWSjh+ibmuZz94tk5zWtXqlR7KsDMuDbp1327wRSlQhpgmFuTucqnoCrQILYNItpN+DTfA5XqoiyHaxSyC8lFXq6T4uYNwN+c02D8hISC7GK3hRP9rUuUIc9wzm7nz+N8KVGJNO+8Gw/7vIonYE5ghhHfJzohPErj7Nj0nokzvzANPwqy8BvnhhN62EX4CyghHuc6KK9RrfC8iuNOOC9fhBZ/YsIrVdBt8MxiDYnoPaTJHy9Sz/VwKfrjH8ZghgqVtkIjPFOVOMFCIGzv9Yo25hT794oUMJnkf+TjihmpADwvA2GWQcARXDqbTBqOOkLs1C6+MVDjz84MYMAPGo5qfjjqLE7kwP/8Rz5TOPNr/ZkVdY4o5UQaZzuJCsaEzJEGgRdppBZil4O4Wz7kjPf/4mdWUwH7l8szXOEoPMCF3xc4/9/6odu+9vXx9R24zB34D2JQy7J6as8UAAAAAElFTkSuQmCC');
              }
              .point {
                background-image: url('data:image/png;base64,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');
              }
              .yellowCard,
              .redCard {
                position: relative;
                display: block;
                width: 22px;
                height: 22px;
                &::before {
                  position: absolute;
                  left: 2px;
                  top: 0;
                  z-index: 2;
                  content: '\20';
                  width: 18px;
                  height: 100%;
                }
              }
              .yellowCard {
                &::before {
                  background-color: #f4e336;
                }
              }
              .redCard {
                &::before {
                  background-color: #c80505;
                }
              }
              .injured {
                width: auto;
                padding: 0 5px;
                font-size: 20px;
                line-height: 26px;
                color: #fff;
                background-color: #e24d23;
                border-radius: 4px;
              }
            }
          }
        }
      }
    }

    .shrinkBox {
      position: absolute;
      bottom: 0;
      left: 0;
      z-index: 10;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      height: 90px;
      width: 100%;
      padding-bottom: 20px;
      color: #007fde;
      background-color: #1c1e23;
      .shrinkText {
        padding-right: 3px;
        font-size: 24px;
      }
      .arrowIcon.unquoteClass {
        width: 0;
        height: 0;
        border-right: 4px solid transparent;
        border-left: 4px solid transparent;
        border-bottom: 6px solid #007fde;
        transform: rotate(0);
        transform-origin: 50% 50%;
        transition: transform 0.3s linear;
        &.show {
          transform: rotate(180deg);
        }
      }
    }
  }
}
</style>
